import { render, staticRenderFns } from "./add1.vue?vue&type=template&id=5d3ef03d&scoped=true&"
import script from "./add1.vue?vue&type=script&lang=js&"
export * from "./add1.vue?vue&type=script&lang=js&"
import style0 from "./add1.vue?vue&type=style&index=0&id=5d3ef03d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ef03d",
  null
  
)

export default component.exports